import * as React from 'react';

function SvgPlusSign(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.167 9.167v-5h1.666v5h5v1.666h-5v5H9.167v-5h-5V9.167h5z"
        fill="#895FC6"
      />
    </svg>
  );
}

export default SvgPlusSign;
